// ============================================
// CONFIGURATION DATA - Easy to Update
// ============================================

export const PROFILE_DATA = {
  name: "Charlie Archer Simmons",
  title: "Security Automation Engineer (Entry-Level)",
  tagline: "Automating tasks and building efficient solutions",
  email: "c.archer.simmons@gmail.com",
  phone: "+44 7544 780145",
  location: {
    city: "London",
    country: "UK",
    timezone: "Europe/London",
    coords: [51.5074, -0.1278]
  },
  social: {
    github: "https://github.com/rar-file",
    linkedin: "https://www.linkedin.com/in/charlie-archer-simmons-a79507398/",
    twitter: "https://rar.codes",
    website: "https://rar.codes"
  },
  bio: "Trainee Automotive Engineer with experience working with companies to automate time-consuming tasks. Proficient in Python and Go, with knowledge of JavaScript, HTML, and CSS. Passionate about creating efficient automation solutions.",
  yearsOfExperience: 4,
  specializations: [
    "Python Development",
    "Go Programming",
    "JavaScript",
    "HTML & CSS",
    "Task Automation",
    "Process Optimization"
  ]
};

export const TECH_STACK = [
  { name: "Docker", level: 98, category: "DevOps" },
  { name: "Python", level: 88, category: "Programming" },
  { name: "Go", level: 85, category: "Programming" },
  { name: "Linux", level: 94, category: "OS" }
];

export const EXPERIENCE = [
  {
    id: 1,
    company: "Silly Developments Ltd",
    logo: "https://sillydev.co.uk/assets/images/logo-sillydev-circle.png",
    role: "Co-Owner/ Security Automation Engineer",
    period: "2024 - Present",
    location: "London, UK",
    description: "Leading infrastructure modernization and automation initiatives",
    achievements: [
      "Automated abuse detection in Docker containers, reducing security incidents by 75%",
      "Migrated data loss by 60% through implementation of robust backup solutions",
      "Implemented custom monitoring dashboards",
      "Built observability platform processing 10TB+ of logs daily with <1s query time"
    ],
    techStack: ["Docker", "AWS", "Python", "Golang",]
  },
  {
    id: 2,
    company: "Work Experience - Teaching Role",
    logo: "🧑‍🏫",
    role: "Assistant Teacher",
    period: "2025 - 2025",
    location: "College",
    description: "Was an assistant teacher for a work experience at a college",
    achievements: [
      "Assisted in teaching basics to students",
      "Developed communication and leadership skills",
      "Converying complex technical concepts in an understandable manner",
    ],
    techStack: ["Communication", "Leadership", "Teaching"]
  },
  {
    id: 3,
    company: "Computer Science - Secondary",
    logo: "🏫",
    role: "Student",
    period: "2021 - 2026",
    location: "school",
    description: "learnt various devops skills and technologies",
    achievements: [
      "Learnted infrastructure as code using Terraform to provision and manage cloud resources",
      "Learnt System architecture and automated deployments using Jenkins pipelines",
      "Developed configuration management skills using Ansible to automate server setups",
    ],
    techStack: ["Python", "Networking", "Security", "Routing"]
  }
];

export const PROJECTS = [
  {
    id: 1,
    title: "Automated Abuse Detection",
    description: "Used advanced detection algorithms to identify and mitigate abusive behaviors in containerized applications, enhancing security and compliance.",
    image: "https://repository-images.githubusercontent.com/649643794/0c481f58-0ab2-42ae-856a-b545cb7afb41",
    techStack: ["Golang", "Python", "Docker", "Pterodactyl"],
    github: "https://sillydev.co.uk",
    demo: "https://sillydev.co.uk",
    metrics: {
      stars: 0,
      forks: 0,
      users: "50000+"
    },
    category: "Detection"
  },
  {
    id: 2,
    title: "Phoney",
    description: "Phoney is a Python library for generating realistic fake personal data—names, phone numbers, emails, ages, birthdates, and full profiles for many locales. Easy to use, fast, and perfect for testing, demos, or anonymizing data.",
    image: "https://i.ibb.co/1JZB9z9z/Banner.png",
    techStack: ["Python", "Faker", "Package", "Data"],
    github: "https://github.com/rar-file/phoney",
    demo: "https://phoney-docs.vercel.app/",
    metrics: {
      stars: 5,
      forks: 2,
      users: "8000+"
    },
    category: "Package"
  },
  {
    id: 3,
    title: "Mini-Memori",
    description: "A lightweight, production-ready memory engine for LLM-based applications. Mini Memori stores conversation history, generates OpenAI embeddings, and retrieves the most relevant memories using semantic search — all backed by a fast local SQLite database. Perfect for building chatbots and AI agents with long-term memory.",
    image: "https://i.ibb.co/TML25gHN/Chat-GPT-Image-Nov-25-2025-12-04-11-AM.png",
    techStack: ["Python", "AI", "Memory", "Architecture"],
    github: "https://github.com/rar-file/Mini-Memori",
    demo: "https://github.com/rar-file/Mini-Memori",
    metrics: {
      stars: 2,
      forks: 1,
      users: "25+"
    },
    category: "Memory Engine"
  },
];

export const WIDGETS_CONFIG = [
  { id: "github", enabled: true, order: 1, title: "GitHub Activity" },
  { id: "spotify", enabled: true, order: 2, title: "Now Playing" },
  { id: "coffee", enabled: true, order: 3, title: "Coffee Tracker" },
  { id: "streak", enabled: true, order: 4, title: "Commit Streak" },
  { id: "blog", enabled: true, order: 5, title: "Latest Articles" },
  { id: "stats", enabled: true, order: 6, title: "Code Statistics" },
  { id: "location", enabled: true, order: 7, title: "Current Location" }
];

export const GITHUB_DATA = {
  username: "rar-file",
  stats: {
    totalPRs: 12,
    totalReviews: 152,
    totalRepos: 64,
    totalContributions: 112
  },
  recentActivity: [
    { type: "pr", repo: "kubernetes/kubernetes", title: "Fix resource leak in controller", date: "2 hours ago" },
    { type: "review", repo: "terraform-aws-modules/terraform-aws-eks", title: "Reviewed: Add support for new instance types", date: "5 hours ago" },
    { type: "commit", repo: "yourusername/k8s-autoscaler", title: "Implement predictive scaling algorithm", date: "1 day ago" },
    { type: "issue", repo: "prometheus/prometheus", title: "Commented on: Memory leak in v2.45", date: "2 days ago" }
  ]
};

export const SPOTIFY_DATA = {
  isPlaying: true,
  track: "Lofi Study Mix",
  artist: "Chillhop Music",
  album: "Focus Flow",
  albumArt: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=300&h=300&fit=crop",
  progress: 65
};

export const COMMIT_DATA = {
  currentStreak: 47,
  longestStreak: 156,
  totalCommits: 2847,
  languageBreakdown: [
    { name: "Python", percentage: 35, color: "#3572A5" },
    { name: "Go", percentage: 28, color: "#00ADD8" },
    { name: "JavaScript", percentage: 18, color: "#F7DF1E" },
    { name: "HCL", percentage: 12, color: "#7B42BC" },
    { name: "Shell", percentage: 7, color: "#89E051" }
  ]
};

export const COFFEE_DATA = {
  today: 4,
  todayGoal: 5,
  week: 28,
  weekGoal: 35,
  total: 3847,
  avgPerDay: 4.2
};

export const BLOG_POSTS = [
  {
    id: 1,
    title: "Mastering Minimalist Web Design",
    excerpt: "How simplicity improves user experience and performance",
    date: "2024-12-05",
    readTime: "6 min",
    url: "https://rar.codes/#blogs"
  },
  {
    id: 2,
    title: "A Developer's Guide to Staying Focused",
    excerpt: "Practical habits to boost concentration in a noisy world",
    date: "2024-12-01",
    readTime: "4 min",
    url: "https://rar.codes/#blogs"
  },
  {
    id: 3,
    title: "Understanding Event-Driven Architecture",
    excerpt: "Why modern systems rely on asynchronous communication",
    date: "2024-11-28",
    readTime: "7 min",
    url: "https://rar.codes/#blogs"
  },
  {
    id: 4,
    title: "Debugging Like a Pro",
    excerpt: "Techniques to isolate issues quickly and efficiently",
    date: "2024-11-22",
    readTime: "5 min",
    url: "https://rar.codes/#blogs"
  },
  {
    id: 5,
    title: "Why Side Projects Make Better Developers",
    excerpt: "Exploring how tinkering sharpens creativity and problem-solving",
    date: "2024-11-18",
    readTime: "6 min",
    url: "https://rar.codes/#blogs"
  }
];

export const CODE_STATS = {
  linesWritten: "1.4M+",
  languages: 6,
  projects: 42,
  pullRequests: 12
};
